import { useState, useEffect } from "react";
import { Button } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { Vocabulary } from "../../Utils/Vocabulary";
import { Subscription } from "../../Utils/Types";
import RenewSubscriptionModal from "./RenewSubscriptionModal";
import { getPublicData } from "../../Services/getPublicData";
import { endpoints } from "../../Utils/UrlEnum";
import styles from "./RenewSubscriptionButton.module.css";

interface RenewSubscriptionButtonProps {
  currentSubscription: Subscription | null;
  clientData?: any;
  className?: string;
}

export default function RenewSubscriptionButton({
  currentSubscription,
  clientData,
  className,
}: RenewSubscriptionButtonProps) {
  const [openModal, setOpenModal] = useState(false);
  const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);
  const [loading, setLoading] = useState(false);

  const handleOpenModal = async () => {
    setOpenModal(true);
    if (subscriptions.length === 0) {
      await fetchSubscriptions();
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const fetchSubscriptions = async () => {
    setLoading(true);
    try {
      const response = (await getPublicData(endpoints.subscriptions)) as any;
      if (response && !response.error) {
        const data = (response.data || response || []).map(
          (sub: any, index: number) => ({
            ...sub,
            isPopular: index === 0,
          })
        );
        setSubscriptions(data);
      }
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch subscriptions once on component mount
  useEffect(() => {
    if (openModal && subscriptions.length === 0) {
      fetchSubscriptions();
    }
  }, [openModal]);

  return (
    <>
      <Button
        variant="contained"
        endIcon={<ArrowForward />}
        onClick={handleOpenModal}
        className={`${styles.modernButton} ${className || ""}`}
      >
        {Vocabulary.renewSubscriptionMonth}
      </Button>

      <RenewSubscriptionModal
        open={openModal}
        onClose={handleCloseModal}
        currentSubscription={currentSubscription}
        availableSubscriptions={subscriptions}
        clientData={clientData}
        loading={loading}
      />
    </>
  );
}
